import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // Form submit hone par page refresh hone se rokega
    try {
      const response = await axios.post(
        "https://admin.butterlive.co.in/management/login",
        {
          username,
          password,
        }
      );

      localStorage.setItem("token", response.data.token);

      // Routing theek hone ke baad yeh turant redirect kam karega
      navigate("/live-users");
    } catch (error) {
      alert("Invalid Username or Password");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1 className="login-logo">Butter Live</h1>

        <p className="login-text">Login to Management Portal</p>

        {/* Form Tag Added here */}
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
